import { customFormat, parseCalendarDate } from 'utils/dateUtils'

const AXIS_DATE_FORMAT = 'MMM d'

const EMPTY_STATUS_OVER_TIME = {
  available: false,
  assigned: null,
  labels: [],
  series: [],
  deadlineIndex: null,
  extendedDeadlineIndex: null,
  todayIndex: null,
  empty: true,
}

export const formatStatusOverTimeLabel = (isoDate) => {
  const date = parseCalendarDate(isoDate)
  if (!date) {
    return isoDate || ''
  }

  return customFormat(date, AXIS_DATE_FORMAT)
}

const isInactivePoint = (point) => !point || (point.completed === 0 && point.inProgress === 0)

export const adaptCampaignStatusOverTime = (payload) => {
  if (!payload?.available) {
    return EMPTY_STATUS_OVER_TIME
  }

  const series = payload.series || []
  let todayIndex = null
  for (let i = series.length - 1; i >= 0; i -= 1) {
    if (series[i] != null) {
      todayIndex = i
      break
    }
  }

  return {
    available: true,
    assigned: payload.assigned,
    labels: (payload.labels || []).map(formatStatusOverTimeLabel),
    series,
    deadlineIndex: payload.deadlineIndex ?? null,
    extendedDeadlineIndex: payload.extendedDeadlineIndex ?? null,
    todayIndex,
    empty: series.every(isInactivePoint),
  }
}
